<template>
  <div class="question">
    <div class="return" @click="back">
      <img
        class="return-img"
        src="https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/return.png"
        alt=""
      />
    </div>
    <div id="leafContainer"></div>
    <div class="question-container">
      <div class="question-page">
        <div class="label-container">
          <div class="label" style='background: url("https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/Q3.png")
            no-repeat; background-size: 100%; background-position: center;'>Q1.</div>
          <div class="title">
            Where would you like to spend your Christmas vacation?
          </div>
        </div>
        <div class="answer">
          <div
            :class="{
              'answer-list': true,
              'answer-list-down': true,
              'answer-list-active': selectStatus[1] === 1,
            }"
            @click="select(1, 1)"
          >
            <img
              class="answer-list-img"
              src="https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/question_new/31.png"
              alt="funny"
            />
            <div class="img-info">New York</div>
          </div>
          <div
            :class="{
              'answer-list': true,
              'answer-list-down': false,
              'answer-list-active': selectStatus[1] === 2,
            }"
            @click="select(1, 2)"
          >
            <img
              class="answer-list-img"
              src="https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/question_new/32.png"
              alt="funny"
            />
            <div class="img-info">Finland</div>
          </div>
          <div
            :class="{
              'answer-list': true,
              'answer-list-down': true,
              'answer-list-active': selectStatus[3] === 3,
            }"
            @click="select(1, 3)"
          >
            <img
              class="answer-list-img"
              src="https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/question_new/33.png"
              alt="funny"
            />
            <div class="img-info">London</div>
          </div>
          <div
            :class="{
              'answer-list': true,
              'answer-list-down': false,
              'answer-list-active': selectStatus[1] === 4,
            }"
            @click="select(1, 4)"
          >
            <img
              class="answer-list-img"
              src="https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/question_new/34.png"
              alt="funny"
            />
            <div class="img-info">Sydney</div>
          </div>
        </div>
      </div>
      <div class="line">
        <img
          src="https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/line1.png"
        />
      </div>
      <div class="question-page">
        <div class="label-container">
          <div class="label" style='background: url("https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/Q2.png")
            no-repeat; background-size: 100%; background-position: center;'>Q2.</div>
          <div class="title">What do you want most for Christmas?</div>
        </div>
        <div class="answer">
          <div
            :class="{
              'answer-list': true,
              'answer-list-down': false,
              'answer-list-active': selectStatus[2] === 1,
            }"
            @click="select(2, 1)"
          >
            <img
              class="answer-list-img"
              src="https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/question_new/21.png"
              alt="funny"
            />
            <div class="img-info">Money</div>
          </div>
          <div
            :class="{
              'answer-list': true,
              'answer-list-down': true,
              'answer-list-active': selectStatus[2] === 2,
            }"
            @click="select(2, 2)"
          >
            <img
              class="answer-list-img"
              src="https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/question_new/221.png"
              alt="funny"
            />
            <div class="img-info">Guitar</div>
          </div>
          <div
            :class="{
              'answer-list': true,
              'answer-list-down': false,
              'answer-list-active': selectStatus[2] === 3,
            }"
            @click="select(2, 3)"
          >
            <img
              class="answer-list-img"
              src="https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/question_new/23.png"
              alt="funny"
            />
            <div class="img-info">Dress</div>
          </div>
          <div
            :class="{
              'answer-list': true,
              'answer-list-down': true,
              'answer-list-active': selectStatus[2] === 4,
            }"
            @click="select(2, 4)"
          >
            <img
              class="answer-list-img"
              src="https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/question_new/24.png"
              alt="funny"
            />
            <div class="img-info">Book</div>
          </div>
        </div>
      </div>
      <div class="line">
        <img
          src="https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/LINE2.png"
        />
      </div>
      <div class="question-page">
        <div class="label-container">
          <div class="label" style='background: url("https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/Q11.png")
            no-repeat; background-size: 100%; background-position: center;'>Q3.</div>
          <div class="title">Which is your favorite “Ugly Sweater”?</div>
        </div>
        <div class="answer">
          <div
            :class="{
              'answer-list': true,
              'answer-list-down': true,
              'answer-list-active': selectStatus[3] === 1,
            }"
            @click="select(3, 1)"
          >
            <img
              class="answer-list-img"
              src="https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/question_new/11.png"
              alt=""
            />
          </div>
          <div
            :class="{
              'answer-list': true,
              'answer-list-down': false,
              'answer-list-active': selectStatus[3] === 2,
            }"
            @click="select(3, 2)"
          >
            <img
              class="answer-list-img"
              src="https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/question_new/12.png"
              alt=""
            />
          </div>
          <div
            :class="{
              'answer-list': true,
              'answer-list-down': true,
              'answer-list-active': selectStatus[3] === 3,
            }"
            @click="select(3, 3)"
          >
            <img
              class="answer-list-img"
              src="https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/question_new/13.png"
              alt=""
            />
          </div>
          <div
            :class="{
              'answer-list': true,
              'answer-list-down': false,
              'answer-list-active': selectStatus[3] === 4,
            }"
            @click="select(3, 4)"
          >
            <img
              class="answer-list-img"
              src="https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/question_new/14.png"
              alt="funny"
            />
          </div>
        </div>
      </div>
      <div class="submit-button">
        <button
          @click="submit"
          :disabled="!isSelect"
          :class="{
            'submit-button__default': !isSelect,
            'submit-button__active': isSelect,
          }"
        >
          submit
        </button>
      </div>
    </div>
  </div>
</template>

<script>
/* global gtag */

export default {
  name: 'question',
  data () {
    return {
      downHeight: 0,
      NUMBER_OF_LEAVES: 50,
      // done: false,
      selectStatus: {
        1: 0,
        2: 0,
        3: 0
      },
      score: {
        1: {
          1: ['stylishSanta', 2],
          2: ['alcoholicSanta', 2],
          3: ['astronautSanta', 2],
          4: ['surfingSanta', 3]
        },
        2: {
          1: ['richSanta', 3],
          2: ['supercoolSanta', 3],
          3: ['stylishSanta', 3],
          4: ['astronautSanta', 3]
        },
        3: {
          1: ['astronautSanta', 2],
          2: ['alcoholicSanta', 3],
          3: ['richSanta', 2],
          4: ['stylishSanta', 2]
        }
      },
      santaScoreList: {
        alcoholicSanta: 0,
        astronautSanta: 0,
        richSanta: 0,
        stylishSanta: 0,
        supercoolSanta: 0,
        surfingSanta: 0
      },
      isSelect: false
    }
  },
  methods: {
    next (step) {
      this.downHeight = this.clientHeight * step * -1
    },
    back () {
      console.log('123')
      this.$router.go(-1)
    },
    submit () {
      gtag('event', 'Xmas_quiz_page_submit_btn_click')
      console.log('123')
      // 提交前清空santaScoreList得分
      Object.keys(this.santaScoreList)
        .forEach((santaItem) => {
          this.santaScoreList[santaItem] = 0
        })
      Object.keys(this.selectStatus).forEach((item) => {
        // 获取每道题的选择项
        const selectOption = this.selectStatus[item]
        if (selectOption !== 0) {
          // 获取该项的得分
          const selectScore = this.score[item][selectOption]
          // 为得分项对应的圣诞老人加分
          this.santaScoreList[selectScore[0]] += selectScore[1]
        }
      })
      // 定义一个容器，存储得分最高的圣诞老人,并把alcoholicSanta得分添加进去
      const maxSantaScore =
          {
            santaName: 'alcoholicSanta',
            santaScore: this.santaScoreList['alcoholicSanta']
          }
      // 遍历圣诞老人得分项
      Object.keys(this.santaScoreList).forEach((santaItem) => {
        // 比较当前容器圣诞老人得分和遍历的圣诞老人得分高低,如果低于则弹出，添加新的
        if (maxSantaScore.santaScore < this.santaScoreList[santaItem]) {
          maxSantaScore.santaName = santaItem
          maxSantaScore.santaScore = this.santaScoreList[santaItem]
        }
      })
      // 获取最高分圣诞老人个数并存到起来
      const maxSanta = []
      Object.keys(this.santaScoreList).forEach((santaItem) => {
        if (this.santaScoreList[santaItem] === maxSantaScore.santaScore) {
          maxSanta.push(santaItem)
        }
      })
      const santaName = maxSanta[Math.floor(Math.random() * maxSanta.length)]
      this.$router.push({ name: 'result', params: { santaName: santaName } })
    },
    // questionNumber: 选择的题号，比如第一题，第二题； answerNumber：选择的答案序号，比如A、B、C、D
    select (questionNumber, answerNumber) {
      gtag('event', `Xmas_quiz_page_question_${questionNumber}_click`)
      console.log(gtag)
      console.log(questionNumber, answerNumber)
      this.selectStatus[questionNumber] = answerNumber
      this.isSelect = true
      if (questionNumber !== 3) {
        // 获取question内容
        const questionPage = document.querySelector('.question-page')
        const stepHeight = window.pageYOffset + questionPage.offsetHeight
        window.scrollBy(0, stepHeight)
      }
    },
    initSnow () {
      var container = document.getElementById('leafContainer')
      for (var i = 0; i < this.NUMBER_OF_LEAVES; i++) {
        container.appendChild(this.createALeaf())
      }
    },
    randomInteger (low, high) {
      return low + Math.floor(Math.random() * (high - low))
    },
    randomFloat (low, high) {
      return low + Math.random() * (high - low)
    },
    pixelValue (value) {
      return value + 'px'
    },
    durationValue (value) {
      return value + 's'
    },
    createALeaf () {
      var leafDiv = document.createElement('div')
      var image = document.createElement('img')
      image.src =
        'https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/snow' +
        this.randomInteger(1, 5) +
        '.png'
      leafDiv.style.top = '-10px'
      leafDiv.style.left = this.pixelValue(this.randomInteger(0, 1000))
      var spinAnimationName =
        Math.random() < 0.5 ? 'clockwiseSpin' : 'counterclockwiseSpinAndFlip'
      leafDiv.style.webkitAnimationName = 'fade, drop'
      image.style.webkitAnimationName = spinAnimationName
      var fadeAndDropDuration = this.durationValue(this.randomFloat(5, 30))
      var spinDuration = this.durationValue(this.randomFloat(3, 24))
      leafDiv.style.webkitAnimationDuration =
        fadeAndDropDuration + ', ' + fadeAndDropDuration
      var leafDelay = this.durationValue(this.randomFloat(0, 4))
      leafDiv.style.webkitAnimationDelay = leafDelay + ', ' + leafDelay
      image.style.webkitAnimationDuration = spinDuration
      leafDiv.appendChild(image)
      return leafDiv
    }
  },
  computed: {
    clientHeight () {
      // 获取屏幕像素密度
      const devicePixelRatio = window.devicePixelRatio || 1
      return document.documentElement.clientHeight * devicePixelRatio
    },
    done () {
      return [1, 2, 3].reduce(
        (total, current, idx, arr) => total * this.selectStatus[current],
        1
      )
    }
  },
  watch: {
    done (val) {
      console.log('val', val)
      if (val !== 0) {
        this.submit()
      }
    }
  },
  mounted () {
    gtag('event', 'Xmas_quiz_page_show')
    this.initSnow()
  },
  created () {
    // 获取上一步答题获取的圣诞老人形象分
    const isStartIn = this.$route.params.isStartIn
    if (!isStartIn) {
      this.$router.push('/start')
    }
  }
}
</script>

<style>
#leafContainer {
  position: fixed;
  pointer-events: none;
  z-index: 0;
  width: 100%;
  height: 100%;
  top: 0;
  overflow: hidden;
}

#leafContainer > div {
  position: absolute;
  max-width: 100px;
  max-height: 100px;
  z-index: 0;
  animation-iteration-count: infinite, infinite;
  -webkit-animation-iteration-count: infinite, infinite;
  animation-direction: normal, normal;
  -webkit-animation-direction: normal, normal;
  animation-timing-function: linear, ease-in;
  -webkit-animation-timing-function: linear, ease-in;
}

#leafContainer > div > img {
  width: 100%;
  z-index: 0;
  animation-iteration-count: infinite;
  -webkit-animation-iteration-count: infinite;
  animation-direction: alternate;
  -webkit-animation-direction: alternate;
  animation-timing-function: ease-in-out;
  -webkit-animation-timing-function: ease-in-out;
  transform-origin: 50% -100%;
  -webkit-transform-origin: 50% -100%;
}

@keyframes fade {
  0% {
    opacity: 1;
  }
  95% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@-webkit-keyframes fade {
  0% {
    opacity: 1;
  }
  95% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@keyframes drop {
  0% {
    -webkit-transform: translate(0px, -50px);
  }
  100% {
    -webkit-transform: translate(0px, 60rem);
  }
}

@-webkit-keyframes drop {
  0% {
    -webkit-transform: translate(0px, -50px);
  }
  100% {
    -webkit-transform: translate(0px, 60rem);
  }
}

@keyframes clockwiseSpin {
  0% {
    -webkit-transform: rotate(-50deg);
  }
  100% {
    -webkit-transform: rotate(50deg);
  }
}

@-webkit-keyframes clockwiseSpin {
  0% {
    -webkit-transform: rotate(-50deg);
  }
  100% {
    -webkit-transform: rotate(50deg);
  }
}

@keyframes counterclockwiseSpinAndFlip {
  0% {
    -webkit-transform: scale(-1, 1) rotate(50deg);
  }
  100% {
    -webkit-transform: scale(-1, 1) rotate(-50deg);
  }
}

@-webkit-keyframes counterclockwiseSpinAndFlip {
  0% {
    -webkit-transform: scale(-1, 1) rotate(50deg);
  }
  100% {
    -webkit-transform: scale(-1, 1) rotate(-50deg);
  }
}
</style>

<style lang="less" scoped>
.question {
  background: url(https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/sonwsnow.png), url(https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/fillSnow.png), linear-gradient(#c5a2b2, #3f2f62);
  background-repeat: no-repeat, repeat, no-repeat;
  background-size: contain;
  .return {
    z-index: 999;
    position: fixed;
    // pointer-events: none;
    top: 1rem;
    left: 1rem;
    background-color: #000;
    width: 1.7rem;
    height: 1.7rem;
    display: flex;
    justify-content: center;
    border-radius: 50%;
    align-items: center;
    .return-img {
      width: 1.26rem;
      height: 1.26rem;
    }
  }
  .question-container {
    z-index: 10;
    padding-bottom: 1rem;
    padding-top: 3rem;
    .question-page {
      // height: 16rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin: 0 1rem;
      .label-container {
        // margin-top: 2rem;
        display: flex;
        align-items: center;
        margin-bottom: 2rem;
        .label {
          width: 4.6rem;
          height: 4.6rem;
          color: #895a6a;
          text-align: center;
          line-height: 4.6rem;
          font-size: 1.26rem;
          font-weight: bolder;
        }
        .title {
          width: 11.2rem;
          color: #fff;
          font-size: 1.1rem;
          font-weight: bolder;
          margin-left: 0.74rem;
        }
      }
      .answer {
        margin-top: 0rem;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        .answer-list {
          width: 6.74rem;
          border-radius: 1.47rem;
          margin-bottom: 1.26rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          .img-info {
            margin-top: 0.4rem;
              color: #E4E5E7;
              font-size: 0.58rem;
              font-weight: bolder;
          }
        }
        .answer-list-img {
          width: 6.74rem;
          height: 6.74rem;
          border-radius: 1.47rem;
        }
        .answer-list-down {
          // margin-top: 2rem;
        }
        .answer-list-active {
          position: relative;
          &::before {
            content: "";
            background-color: rgba(0, 0, 0, 0.7);
            // border: 0.15rem solid #ffffff;
            border-radius: 1.47rem;
            position: absolute;
            z-index: 15;
            width: 6.44rem;
            height: 6.44rem;
            border: 0.15rem solid #fff;
          }
          &:after {
            content: "";
            background: url("https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/select1.png")
              no-repeat bottom right / 1rem 1rem;
            position: absolute;
            bottom: -0.2rem;
            right: -0.2rem;
            z-index: 20;
            width: 1rem;
            height: 1rem;
          }
        }
      }
    }
    .line {
      margin: 1rem 0.5rem;
      img {
        width: 100%;
      }
    }
    .submit-button {
      width: 100%;
      margin: 1rem 0;
      text-align: center;
      .submit-button__default {
        border: none;
        width: 13rem;
        height: 2.8rem;
        background: rgba(0, 0, 0, 0.2);
        border-radius: 2.8rem;
        font-size: 1rem;
        font-weight: bold;
        color: rgba(255, 255, 255, 0.4);
        line-height: 1rem;
      }
      .submit-button__active {
        border: none;
        width: 13rem;
        height: 2.8rem;
        background: rgba(255, 255, 255, 0.05);
        box-shadow: 0px 0.1rem 0.6rem 0px rgba(37, 4, 50, 0.33),
          inset 0px 0.1rem 1rem 0px rgba(255, 255, 255, 0.2),
          inset 0rem 0rem 0.6rem 0rem #ffffff;
        border-radius: 2.8rem;
        font-size: 1rem;
        font-weight: bold;
        color: #fff;
        line-height: 1rem;
        animation: button__question 1.5s linear 1s infinite;
      @keyframes button__question {
        0% {
                -webkit-transform: scale(1);
                transform: scale(1)
            }
          25% {
                -webkit-transform: scale(1.1);
                transform: scale(1.1)
            }
            50% {
                -webkit-transform: scale(1);
                transform: scale(1)
            }
            75% {
                -webkit-transform: scale(0.9);
                transform: scale(0.9)
            }
            100% {
                -webkit-transform: scale(1);
                transform: scale(1)
            }
      }
      }
    }
  }
}
</style>
